import React, {Fragment, useCallback, useEffect, useState} from "react";
import {
    Button,
    Card,
    CardFooter,
    CardHeader,
    Col,
    Container,
    Row,
    Table,
} from "reactstrap";
import {useHistory} from "react-router";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import PaginationWrapper from "../components/pagination";
import useHistoryState from "../../../common/useHistoryState";
import {numberWithCommas} from "../../../utils";
import sharingPloggingService from "./service/sharingPlogging.service";

const getErrorMessage = (e, fallback) => {
    return e?.response?.data?.resultMsg || e?.response?.data?.message || fallback;
};

const formatUsageTime = (value) => {
    if (!value) {
        return "0시간";
    }
    const [hours = "0"] = String(value).split(":");
    return `${Number(hours) || 0}시간`;
};

function SharedPloggingMgmt() {
    const history = useHistory();
    const [pageActive, setPageActive] = useHistoryState(1, "sharedPloggingPageActive");
    const [pageCount, setPageCount] = useState(1);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const render = useCallback(async () => {
        setLoading(true);
        try {
            const res = await sharingPloggingService.list({
                page: pageActive,
                limit: 15,
            });

            if (res.code === 200) {
                setPageCount(res.list.count || 0);
                setData(res.list.rows || []);
            }
        } catch (e) {
            alert("나눔플로깅 목록을 불러오지 못했습니다.");
        } finally {
            setLoading(false);
        }
    }, [pageActive]);

    useEffect(() => {
        render();
    }, [render]);

    const handleToggleActive = async (item) => {
        const nextActive = !item.active;
        try {
            setData(prev => prev.map(each => each.id === item.id ? {...each, active: nextActive} : each));
            await sharingPloggingService.update(item.id, {active: nextActive});
        } catch (e) {
            setData(prev => prev.map(each => each.id === item.id ? {...each, active: item.active} : each));
            alert(getErrorMessage(e, "활성 여부를 변경하지 못했습니다."));
        }
    };

    return (
        <>
            <SimpleHeader name="Tables" parentName="Tables"/>
            <Container className="mt--6" fluid>
                <Row>
                    <div className="col">
                        <Card>
                            <CardHeader className="border-0">
                                <Row>
                                    <Col xs="6">
                                        <h3 className="mt-2">나눔플로깅 관리</h3>
                                    </Col>
                                    <Col className="text-right">
                                        <Button
                                            color="default"
                                            onClick={() => history.push("/admin/sharingPlogging/register")}
                                        >
                                            등록하기
                                        </Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <Table className="align-items-center table-flush" responsive striped>
                                <thead className="thead-light">
                                <tr>
                                    <th className="text-center">봉사센터명</th>
                                    <th className="text-center">센터 로그인 아이디</th>
                                    <th className="text-center">우선순위</th>
                                    <th className="text-center">1인 기준 월 기부 전달 금액</th>
                                    <th className="text-center">결제 금액</th>
                                    <th className="text-center">이용시간</th>
                                    <th className="text-center">이용 건수</th>
                                    <th className="text-center">활성 여부</th>
                                    <th className="text-center">관리</th>
                                </tr>
                                </thead>
                                <tbody>
                                {!loading && data.map((item, i) => (
                                    <Fragment key={item.id}>
                                        <tr>
                                            <td className="text-center">{item.center}</td>
                                            <td className="text-center">{item.centerLoginId}</td>
                                            <td className="text-center">{item.priority ?? 0}</td>
                                            <td className="text-center">{numberWithCommas(item.price)}원</td>
                                            <td className="text-center">{numberWithCommas(item.payAmount)}원</td>
                                            <td className="text-center">{formatUsageTime(item.totalUsageTime)}</td>
                                            <td className="text-center">{numberWithCommas(item.workingCount)}</td>
                                            <td className="text-center">
                                                <label className="custom-toggle custom-toggle-success m-0">
                                                    <input
                                                        checked={!!item.active}
                                                        type="checkbox"
                                                        onChange={() => handleToggleActive(item)}
                                                    />
                                                    <span
                                                        className="custom-toggle-slider rounded-circle"
                                                        data-label-off="Off"
                                                        data-label-on="On"
                                                    />
                                                </label>
                                            </td>
                                            <td className="text-center">
                                                <Button
                                                    className="btn-outline-default"
                                                    size="sm"
                                                    onClick={() => history.push(`/admin/sharingPlogging/detail/${item.id}`)}
                                                >
                                                    상세
                                                </Button>
                                            </td>
                                        </tr>
                                    </Fragment>
                                ))}
                                {!loading && data.length === 0 && (
                                    <tr>
                                        <td className="text-center" colSpan="9">
                                            등록된 나눔플로깅이 없습니다.
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </Table>
                            <CardFooter className="py-4">
                                <PaginationWrapper
                                    isActive={pageActive}
                                    pageNumber={pageCount}
                                    callback={(page) => setPageActive(page)}
                                    itemPerPage={15}
                                />
                            </CardFooter>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
}

export default SharedPloggingMgmt;
